import { render, staticRenderFns } from "./SummaryBrandCombine.vue?vue&type=template&id=5262d882"
import script from "./SummaryBrandCombine.vue?vue&type=script&lang=js"
export * from "./SummaryBrandCombine.vue?vue&type=script&lang=js"
import style0 from "./SummaryBrandCombine.vue?vue&type=style&index=0&id=5262d882&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports